/**
 * DeleteGroupDialog — confirmation dialog for user group deletion.
 *
 * Props:
 *   open       — dialog visibility
 *   groupName  — name of the group being deleted
 *   count      — number of groups (for bulk delete)
 *   onClose    — cancel callback
 *   onConfirm  — confirm delete callback
 *   saving     — boolean, disables buttons while deleting
 */

const DeleteGroupDialog = ({ open, groupName, count, onClose, onConfirm, saving }) => {
    if (!open) return null;

    const isBulk = count > 1;
    const title = isBulk ? `Delete ${count} Groups` : 'Delete Group';
    const message = isBulk
        ? `Are you sure you want to delete ${count} group${count !== 1 ? 's' : ''}? This action cannot be undone.`
        : (<>Are you sure you want to permanently delete <strong>{groupName}</strong>? This action cannot be undone.</>);

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 10000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(0, 0, 0, 0.4)',
            }}
            onClick={onClose}
        >
            <div
                style={{
                    background: 'var(--color-bg-primary, #fff)',
                    borderRadius: 'var(--radius-lg, 0.75rem)',
                    boxShadow: 'var(--shadow-xl)',
                    width: '100%',
                    maxWidth: '440px',
                    overflow: 'hidden',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div style={{ padding: 'var(--space-4) var(--space-5)', borderBottom: '1px solid var(--color-border)' }}>
                    <h3 style={{ margin: 0, fontSize: 'var(--font-size-lg)', fontWeight: 'var(--font-weight-semibold)', color: 'var(--color-danger)' }}>
                        {title}
                    </h3>
                </div>
                <div style={{ padding: 'var(--space-5)' }}>
                    <p style={{ margin: 0, fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)' }}>
                        {message}
                    </p>
                </div>
                <div style={{ padding: 'var(--space-4) var(--space-5)', display: 'flex', justifyContent: 'flex-end', gap: 'var(--space-3)', borderTop: '1px solid var(--color-border)' }}>
                    <button className="dp-btn dp-btn--cancel" onClick={onClose} disabled={saving}>Cancel</button>
                    <button className="dp-btn dp-btn--danger" onClick={onConfirm} disabled={saving}>
                        {saving ? 'Deleting\u2026' : 'Delete'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteGroupDialog;
